import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'
import Nprogress from 'nprogress';
import router from '@/router/index'
import qs from 'qs'
Vue.use(Vuex)
const state = {
    idToken: null,
    idAdminDetails: null,
    appPermissions: null,

}

const mutations = {
    SET_USER_TOKEN(state, userData) {
        state.idToken = userData.token
    },
    ADD_USER(state, userData) {
        state.idAdminDetails = userData
    },
    REMOVE_AUTH_DATA(state) {
        state.idToken = null
        state.idAdminDetils = null
    },
}

const actions = {

    findLogin({
        commit,
        dispatch
    }, authData) {
        let loader = Vue.$loading.show({
            canCancel: false,
        });
        return new Promise((resolve, reject) => {
            axios.post('/login/login_post', qs.stringify({
                username: authData.username,
                password: authData.password
            }, {
                parseArrays: false
            }))
                .then(res => {
                    loader.hide();
                    if (res.data.status != 'error') {
                        if (res.data.expirationData == undefined) {
                            location.reload()
                        }
                        var now = new Date()
                        var expirationDate = now.getTime() + 2 * 24 * 60 * 60 * 1000;
                        localStorage.setItem('token', res.data.message)
                        if (res.data.expirationData.exp != undefined) {
                            localStorage.setItem('expirationDate', res.data.expirationData.exp * 1000)
                        } else {
                            localStorage.setItem('expirationDate', expirationDate)
                        }

                        commit('SET_USER_TOKEN', {
                            token: res.data.message
                        })
                        if (res.data.paymentAlert == 'overdue') {
                            window.location.href = '/payment/blocked';
                            return;
                        }
                        if (res.data.resellerPayment == 'overdue') {
                            window.location.href = '/franchise_management/resellerBlocked';
                            return;
                        }
                        axios.get('/network_admins/get_admin_details', {
                            headers: {
                                'Authorization': `${localStorage.getItem('token')}`
                            }
                        })
                            .then(res => {
                                localStorage.setItem('adminDetails', res.data.adminDetails)
                                commit('ADD_USER', res.data.adminDetails)
                                resolve(res.data)
                            })
                            .catch(error => console.log(error))
                    } else {
                        reject(res.data.message)
                    }
                })
                .catch(error => {
                    reject(error);
                    console.log(error)
                })
        })
    },

    findAdminOtpLogin({
        commit,
        dispatch
    }, authData){
        let loader = Vue.$loading.show({
            canCancel: false,
        });
        return new Promise((resolve, reject) => {
            var now = new Date()
         var expirationDate = now.getTime() + 2 * 24 * 60 * 60 * 1000;
         localStorage.setItem('token', authData.adminMessage)
         if(authData.expirationDataExp != undefined){
            localStorage.setItem('expirationDate', authData.expirationDataExp * 1000)
         }else{
            localStorage.setItem('expirationDate', expirationDate)
         }
         commit('SET_USER_TOKEN', {
            token: authData.adminMessage
        })
        if (authData.paymentAlert == 'overdue') {
            window.location.href = '/payment/blocked';
            return;
        }
        if (authData.resellerPayment == 'overdue') {
            window.location.href = '/franchise_management/resellerBlocked';
            return;
        }
        axios.get('/network_admins/get_admin_details', {
            headers: {
                'Authorization': `${localStorage.getItem('token')}`
            }
        })
            .then(res => {
                loader.hide();
                localStorage.setItem('adminDetails', res.data.adminDetails)
                commit('ADD_USER', res.data.adminDetails)
                resolve(res.data)
            })
            .catch(error => console.log(error))
        })

    },

    findResetPassword({
        commit,
        dispatch
    }, authData) {
        let loader = Vue.$loading.show({
            canCancel: false,
        });
        return new Promise((resolve, reject) => {
            axios.post('/reset_password', qs.stringify({
                email: authData.username,
                vue: 'true'
            }, {
                parseArrays: false
            }))
                .then(res => {
                    loader.hide();
                    if (res.data.status != 'success') {
                        reject(res.data.message)
                        return;
                    }
                    resolve(res.data.message)
                })
                .catch(error => {
                    reject(error)
                    console.log(error)
                })
        })

    },
    findResetCode({
        commit,
        dispatch
    }, authData) {
        let loader = Vue.$loading.show({
            canCancel: false,
        });
        return new Promise((resolve, reject) => {
            axios.post('/reset_password/code', qs.stringify({
                password: authData.password,
                invite_code: authData.invitecode,
                vue: 'true'
            }, {
                parseArrays: false
            }))
                .then(res => {
                    loader.hide();

                    resolve(res.data)
                })
                .catch(error => {
                    reject(error)
                    console.log(error)
                })
        })

    },
    logout({
        commit
    }) {
        localStorage.removeItem('expirationDate')
        localStorage.removeItem('token')
        localStorage.setItem('token',"logout")
        localStorage.removeItem('adminDetails')
        commit('REMOVE_AUTH_DATA')
        axios.get('/login/logout/true')
            .then(res => {
                loader.hide();
                location.reload();
                resolve(res.data)
            })
            .catch(error => {
                location.reload();
                reject(error)
                console.log(error)
            })
        // window.location.href = "/api/login/logout/true";
    }
}

const getters = {

}

export default {
    state,
    mutations,
    actions,
    getters
}
